import React, { Fragment } from 'react';

const Empty = props => (<Fragment>{props.children}</Fragment>)

export default Empty;